import { render } from "./AccountBody.vue?vue&type=template&id=5ed592aa&scoped=true"
import script from "./AccountBody.vue?vue&type=script&lang=js"
export * from "./AccountBody.vue?vue&type=script&lang=js"

import "./AccountBody.vue?vue&type=style&index=0&id=5ed592aa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed592aa"]])

export default __exports__